module.exports = __webpack_public_path__ + "img/chiesi-logo-white.f9be17de.svg";